const MONTH_CODES = ['A', 'B', 'C', 'D', 'E', 'H', 'L', 'M', 'P', 'R', 'S', 'T'];

const oddMap = {
  '0': 1, '1': 0, '2': 5, '3': 7, '4': 9, '5': 13, '6': 15, '7': 17, '8': 19, '9': 21,
  'A': 1, 'B': 0, 'C': 5, 'D': 7, 'E': 9, 'F': 13, 'G': 15, 'H': 17, 'I': 19, 'J': 21,
  'K': 2, 'L': 4, 'M': 18, 'N': 20, 'O': 11, 'P': 3, 'Q': 6, 'R': 8, 'S': 12, 'T': 14,
  'U': 16, 'V': 10, 'W': 22, 'X': 25, 'Y': 24, 'Z': 23
};

const evenMap = {
  '0': 0, '1': 1, '2': 2, '3': 3, '4': 4, '5': 5, '6': 6, '7': 7, '8': 8, '9': 9,
  'A': 0, 'B': 1, 'C': 2, 'D': 3, 'E': 4, 'F': 5, 'G': 6, 'H': 7, 'I': 8, 'J': 9,
  'K': 10, 'L': 11, 'M': 12, 'N': 13, 'O': 14, 'P': 15, 'Q': 16, 'R': 17, 'S': 18, 'T': 19,
  'U': 20, 'V': 21, 'W': 22, 'X': 23, 'Y': 24, 'Z': 25
};

const controlChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';

const cache = { comuni: null, map: new Map() };
const omocodiaDigitMap = {
  L: '0',
  M: '1',
  N: '2',
  P: '3',
  Q: '4',
  R: '5',
  S: '6',
  T: '7',
  U: '8',
  V: '9',
};

function onlyConsonants(str) {
  return (str || '').replace(/[^A-Z]/gi, '').toUpperCase().replace(/[AEIOU]/g, '');
}

function onlyVowels(str) {
  return (str || '').replace(/[^A-Z]/gi, '').toUpperCase().replace(/[^AEIOU]/g, '');
}

function codeSurname(surname) {
  const cons = onlyConsonants(surname);
  const vows = onlyVowels(surname);
  let res = cons;
  if (res.length < 3) res += vows;
  res = (res + 'XXX').slice(0, 3);
  return res;
}

function codeName(name) {
  const cons = onlyConsonants(name);
  if (cons.length >= 4) {
    return cons[0] + cons[2] + cons[3];
  }
  const vows = onlyVowels(name);
  let res = cons;
  if (res.length < 3) res += vows;
  res = (res + 'XXX').slice(0, 3);
  return res;
}

function codeDate(dateStr, gender) {
  const d = new Date(dateStr);
  const yy = String(d.getFullYear()).slice(-2);
  const mm = MONTH_CODES[d.getMonth()] || 'A';
  let dd = d.getDate();
  if (String(gender).toUpperCase() === 'F') dd += 40;
  const ddStr = String(dd).padStart(2, '0');
  return yy + mm + ddStr;
}

// Control Character Calculation Logic:
// 1. Convert characters to values using odd/even maps
// 2. Sum values
// 3. Remainder of sum / 26
// 4. Map remainder to letter (0->A, 1->B, ..., 25->Z)

function calcControlChar(code15) {
  let sum = 0;
  for (let i = 0; i < code15.length; i++) {
    const c = code15[i];
    sum += (i % 2 === 0) ? oddMap[c] : evenMap[c];
  }
  const idx = sum % 26;
  return controlChars[idx];
}

async function fetchBelfioreCode(placeOrName, provinceIfString) {
  // Case 1: City object with explicit belfiore_code (Foreign Country)
  if (typeof placeOrName === 'object' && placeOrName.belfiore_code) {
    return placeOrName.belfiore_code;
  }

  // Extract name and province
  let cityName, province;
  if (typeof placeOrName === 'object' && placeOrName !== null) {
    cityName = placeOrName.name;
    province = placeOrName.province || placeOrName.sigla;
  } else {
    cityName = placeOrName;
    province = provinceIfString;
  }

  // Handle case where cityName includes country (e.g. "Casablanca (null) - Marocco")
  if (cityName && cityName.includes(' - ')) {
    // If the last part is a known foreign country, we might find it in our country list if we had access to it.
    // However, the best way is to rely on the city object having the belfiore_code if selected from autocomplete.
    // If we are here, it means placeOrName is a string or an object without belfiore_code.
    
    // Try to extract pure city name "Casablanca (null)" -> "Casablanca"
    // But foreign cities don't have provinces usually.
    // Let's assume the user selected a city that SHOULD have had a belfiore_code.
    // If it's missing, we can try to fetch it if we know the country.
  }

  const key = `${(cityName || '').toUpperCase()}|${(province || '').toUpperCase()}`;
  if (cache.map.has(key)) return cache.map.get(key);
  if (!cache.comuni) {
    const res = await fetch('https://raw.githubusercontent.com/matteocontrini/comuni-json/master/comuni.json');
    cache.comuni = await res.json();
  }
  const target = cache.comuni.find(c => c.nome.toUpperCase() === (cityName || '').toUpperCase() && c.sigla.toUpperCase() === (province || '').toUpperCase());
  const code = target ? target.codiceCatastale : null;
  cache.map.set(key, code);
  return code;
}

export async function computeCodiceFiscale({ first_name, last_name, birth_date, gender, birth_place }) {
  if (!first_name || !last_name || !birth_date || !gender || !birth_place) return null;
  const surnameCode = codeSurname(last_name);
  const nameCode = codeName(first_name);
  const dateCode = codeDate(birth_date, gender);
  
  // Pass the whole birth_place object if available to leverage belfiore_code property
  const comuneCode = await fetchBelfioreCode(birth_place, (birth_place && (birth_place.province || birth_place.sigla)) || '');
  
  if (!comuneCode) return null;
  const partial = (surnameCode + nameCode + dateCode + comuneCode).toUpperCase();
  const ctrl = calcControlChar(partial);
  return partial + ctrl;
}

function normalizeCodiceFiscale(value) {
  return String(value || '')
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, '')
    .trim();
}

function decodeOmocodiaDigit(char) {
  const c = String(char || '').toUpperCase();
  if (/^\d$/.test(c)) return c;
  return omocodiaDigitMap[c] ?? null;
}

function decodeTwoDigits(chars) {
  const a = decodeOmocodiaDigit(chars[0]);
  const b = decodeOmocodiaDigit(chars[1]);
  if (!a || !b) return null;
  return `${a}${b}`;
}

function decodeMonthLetter(letter) {
  const idx = MONTH_CODES.indexOf(String(letter || '').toUpperCase());
  if (idx < 0) return null;
  return idx + 1;
}

function formatYmd(d) {
  if (!(d instanceof Date) || Number.isNaN(d.getTime())) return '';
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

function formatDmy(d) {
  if (!(d instanceof Date) || Number.isNaN(d.getTime())) return '';
  const day = String(d.getDate()).padStart(2, '0');
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const y = d.getFullYear();
  return `${day}/${m}/${y}`;
}

async function fetchComuneByBelfioreCode(belfioreCode) {
  const code = String(belfioreCode || '').trim().toUpperCase();
  if (!code || code.length !== 4) return null;
  if (!cache.comuni) {
    const res = await fetch('https://raw.githubusercontent.com/matteocontrini/comuni-json/master/comuni.json');
    cache.comuni = await res.json();
  }
  const target = cache.comuni.find((c) => String(c.codiceCatastale || '').toUpperCase() === code);
  if (!target) return null;
  return { nome: target.nome, sigla: target.sigla, codiceCatastale: target.codiceCatastale };
}

export async function decodeCodiceFiscale(value) {
  const cf = normalizeCodiceFiscale(value);
  if (cf.length !== 16) return null;
  const code15 = cf.slice(0, 15);
  const ctrl = cf[15];
  if (ctrl !== calcControlChar(code15)) return null;

  const yyStr = decodeTwoDigits(cf.slice(6, 8));
  const mm = decodeMonthLetter(cf[8]);
  const ddRawStr = decodeTwoDigits(cf.slice(9, 11));
  if (!yyStr || !mm || !ddRawStr) return null;

  const yy = parseInt(yyStr, 10);
  const ddRaw = parseInt(ddRawStr, 10);
  if (!Number.isFinite(yy) || !Number.isFinite(ddRaw)) return null;

  const currentYY = new Date().getFullYear() % 100;
  const fullYear = yy <= currentYY ? 2000 + yy : 1900 + yy;
  const gender = ddRaw > 40 ? 'F' : 'M';
  const day = ddRaw > 40 ? ddRaw - 40 : ddRaw;
  const birthDate = new Date(fullYear, mm - 1, day, 0, 0, 0, 0);
  if (Number.isNaN(birthDate.getTime())) return null;

  const placeFirst = String(cf[11] || '').toUpperCase();
  const placeNums = [cf[12], cf[13], cf[14]].map((c) => decodeOmocodiaDigit(c));
  if (!placeFirst || placeNums.some((v) => !v)) return null;
  const belfioreCode = `${placeFirst}${placeNums.join('')}`;

  let comune = null;
  if (!belfioreCode.startsWith('Z')) {
    try {
      comune = await fetchComuneByBelfioreCode(belfioreCode);
    } catch (_) {
      comune = null;
    }
  }

  const placeName = comune?.nome ? String(comune.nome) : belfioreCode.startsWith('Z') ? `STATO ESTERO (${belfioreCode})` : belfioreCode;
  const province = comune?.sigla ? String(comune.sigla).toUpperCase() : '';

  return {
    cf,
    gender,
    birthDate,
    birthDateYmd: formatYmd(birthDate),
    birthDateDmy: formatDmy(birthDate),
    belfioreCode,
    birthPlaceName: placeName,
    birthProvince: province,
  };
}
